<template>
  <!-- 我的课程播放 -->
  <div class="index-container">
    <div class="course-container">
      <div class="nav-box">
        首页 > 大健康人才培训 > 个人中心 > 我的课程
        <span>> 课程详情</span>
      </div>
      <div class="detail-title">{{ detailInfo.name }}</div>
      <div class="video-content">
        <div class="video-box">
          <video oncontextmenu="return false;" id="video" :src="videourl" autoplay style="object-fit: contain"></video>
        </div>
        <div class="question-box">
          <div v-for="(item, index) in questionList" :key="index">
            <div class="q-title second-title" v-if="item.child && item.child.length">
              <!-- {{ item.level_name }} -->
              {{ getSectionTitle(courseDetail, item, index) }}
            </div>
            <div
              class="q-words"
              v-for="ele in item.child"
              :key="ele.uuid"
              :class="
                ele.uuid === detailInfo.uuid ? 'is-play' : ele.is_over == -1 && ele.class_model == 1 ? 'no-play' : ''
              "
              @click="playVideo(ele)"
            >
              <div class="q-type" :class="ele.class_model == 1 ? (ele.is_over == -1 ? 'no-type' : 'type-green') : ''">
                {{ ele.class_model == 1 ? "线上" : "线下" }}
              </div>
              <span class="w1">{{ ele.name }}</span>
              <i v-if="ele.is_select == 1" class="iconfont-icon icon-ziyuanldpi"></i>
              <div
                class="m-tool"
                v-if="ele.uuid == detailInfo.uuid"
                style="margin-left: 72px; margin-top: 6px; font-size: 16px"
              >
                <span class="u-w1" style="color: #fff"
                  >已观看{{ Math.floor((detailInfo.play_time / detailInfo.video_long_time) * 100) }}%</span
                >
                <span
                  v-if="detailInfo.paper_uuid && detailInfo.play_time / detailInfo.video_long_time > 0.9"
                  style="margin-left: 10px; color: #52ce0f"
                  @click.stop="toTest(detailInfo.paper_uuid)"
                  class="u-w2"
                  >线上考试</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 去考试界面 -->
    <el-dialog class="form-box" :visible.sync="isShowTestModal" width="480px" top="30vh" :close-on-click-modal="false">
      <div class="m-test">
        <p class="w1">视频已看完，快去考试吧～</p>
        <div class="m-btn" @click="toTest(detailInfo.paper_uuid)">去考试</div>
      </div>
    </el-dialog>

    <!-- 预约线下上课 -->
    <el-dialog class="form-box" :visible.sync="orderVisible" width="582PX" :close-on-click-modal="false">
      <div class="order-title">预约上课</div>
      <template v-if="s_state == 2 || s_state == 0">
        <div class="order-info">
          上课地点
          <el-select v-model="classArea" @change="areaChange" placeholder="请选择校区">
            <el-option
              v-for="(item, index) in classAreaList"
              :key="index + 'area'"
              :label="item.lession_address"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="order-info">
          上课时间
          <span>{{ time_range }}</span>
        </div>
        <div class="order-button" @click="orderCourse">预约</div>
      </template>
      <template v-else>
        <div class v-for="item in orderInfo" :key="item.lession_time">
          <div class="order-info info-box">
            上课地点
            <span>{{ item.lession_address }}</span>
            <div class="road-btn" @click="goGaode(item.lession_address)">
              <i class="iconfont-icon icon-daohang"></i> 去导航
            </div>
          </div>
          <div class="order-info">
            上课时间
            <span>{{ item.lession_time }}</span>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import videoPlayer from "../components/videoPlayer.vue";
import { imgUrl } from "../api/index";
import api from "../api/api";
export default {
  name: "myCoursePlay",
  components: {
    videoPlayer,
  },
  data() {
    return {
      videourl: "",
      imgUrl: imgUrl,
      questionList: [],
      detailInfo: {},
      courseDetail: {},
      duation: "",
      myVideo: "",
      section_uuid: "",
      orderVisible: false,
      orderType: "",
      classArea: "",
      classAreaList: [],
      classTime: "",
      startTime: "",
      endTime: "",
      order_id: "",
      orderInfo: {
        lession_address: "",
        lession_time: "",
      },
      s_state: 0,
      time_range: "",
      section_uuid: "",
      videoTimer: null,
      isShowTestModal: false,
    };
  },
  mounted() {
    scrollTo(0, 0);
    const value = this.$route.query;
    if (value) {
      this.section_uuid = value.uuid;
      this.getMyCourseDetail(value.uuid);
      // this.recordCourseTime();
    }
  },
  watch: {
    myVideo(val) {
      const that = this;
      // const videoTimer = setInterval(() => {
      //   console.log("____________", that.myVideo.currentTime);
      //   // that.recordCourseTime(that.myVideo.currentTime);
      // }, 5000);
      that.myVideo.addEventListener("ended", function (val) {
        clearInterval(this.videoTimer);
        this.videoTimer = null;
        if (val) {
          console.log("完成课程");
          that.recordCourseTime(that.myVideo.currentTime);
          api.courseOver({ section_uuid: that.section_uuid }).then((res) => {
            console.log("xxx", res);
            if (res.result) {
              that.$message.success("已完成该课程学习!");
              if (that.detailInfo.paper_uuid) that.isShowTestModal = true;
            }
          });
        }
      });
      that.myVideo.addEventListener("pause", function (val) {
        clearInterval(this.videoTimer);
        this.videoTimer = null;
        console.log(this.videoTimer);
      });
      that.myVideo.addEventListener("play", function (val) {
        if (val) {
          this.videoTimer = setInterval(() => {
            console.log("播放进度", that.myVideo.currentTime);
            that.recordCourseTime(that.myVideo.currentTime);
          }, 5000);
        }
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.videoTimer);
    this.videoTimer = null;
  },
  methods: {
    // 获取课程标题
    getSectionTitle(detail, item, index) {
      if (index == 0 && detail.high_alias) return detail.common_alias;
      if (index == 1 && detail.middle_alias) return detail.primary_alias;
      if (index == 2 && detail.primary_alias) return detail.middle_alias;
      if (index == 3 && detail.common_alias) return detail.high_alias;
      return `${item.level_name}`;
    },

    recordCourseTime(timeDisplay) {
      const params = {
        section_uuid: this.section_uuid,
        play_time: Math.ceil(timeDisplay),
      };
      api.recordCourseTime(params).then((res) => {
        console.log(res);
        if (res.result) {
        }
      });
    },
    goGaode(address) {
      window.open(`https://www.amap.com/search?query=${address}`, "_blank");
    },
    playVideo(item) {
      console.log(item);
      if (item.is_over == -1) {
        this.$message.warning("请先购买该课程！");
        return;
      }
      if (item.class_model == 1) {
        this.getMyCourseDetail(item.uuid);
      } else {
        this.s_state = item.s_state;
        this.orderVisible = true;
        this.classArea = "";
        this.time_range = "";
        this.section_uuid = item.uuid;
        this.orderInfo = item.class_info;
        this.classAreaList = item.class_info;
      }
    },
    // 地址选择
    areaChange(val) {
      this.classArea = val.lession_address;
      this.time_range = val.lession_time;
    },
    // 预约课程
    orderCourse() {
      if (!this.classArea) {
        this.$message.warning("请选择预约地址和时间！");
        return;
      }
      const params = {
        time_range: this.time_range,
        address: this.classArea,
        section_uuid: this.section_uuid,
        subscribe_type: this.s_state,
      };
      api.courseSubscribe(params).then((res) => {
        if (res.result) {
          this.orderVisible = false;
          this.$message.success("预约成功！");
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 获取我的课程详情
    getMyCourseDetail(uuid) {
      api.getMyCourseDetail({ section_uuid: uuid }).then((res) => {
        if (res.result) {
          this.detailInfo = res.result.section;
          this.questionList = res.result.lession_list;
          this.myVideo = document.getElementById("video");
          //判断url是否http开头
          if (this.detailInfo["vedio"].indexOf("http") == 0) {
            this.videourl = this.detailInfo["vedio"];
          } else {
            this.videourl = this.imgUrl + this.detailInfo["vedio"];
          }
          this.$forceUpdate();

          // 如果看完了 直接弹窗考试弹窗
          if (this.detailInfo.per == "100%") {
            if (this.detailInfo.paper_uuid) that.isShowTestModal = true;
          }

          // 获取原课程详情
          api.getCourseDetail({ uuid: res.result.section.course_uuid }).then((res) => {
            if (!res.result) return;
            this.courseDetail = res.result;
          });
        } else {
          this.$message.warning(res.result.msg);
        }
      });
    },
    // 考试
    toTest(uuid) {
      if (!uuid) return this.$message.error("视频未绑定考试");
      this.$router.push({ path: "/testOnline", query: { id: uuid } });
    },
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122px;
  background-color: #f8f7f6;
}
.course-container {
  width: 72%;
  padding: 50px 0 115px;
  margin: 0 auto;
}
.nav-box {
  font-size: 16px;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.video-content {
  display: flex;
  height: 662px;
  background-color: #1e1e1e;
}
.video-box {
  width: 72%;
  height: 99%;
  // height: 662PX;
  >>> .barrage-box {
    margin-bottom: 0;
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
}
.question-box {
  width: 28%;
  padding-left: 30px;
  background-color: #1e1e1e;
  overflow-y: auto;
  .q-title {
    padding: 6px 0 15px;
    margin-bottom: 28px;
    font-size: 22px;
    color: #ffffff;
    border-bottom: 1px solid #ffffff;
  }
  .second-title {
    padding-top: 20px;
  }
}
.q-words {
  // display: flex;
  width: 100%;
  padding-right: 10px;
  margin-bottom: 24px;
  font-size: 16px;
  color: #ffffff;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  .w1:hover {
    color: #f1a373;
  }
  .iconfont-icon {
    padding-left: 10px;
  }
}
.is-play {
  color: #f1a373;
}
.no-play {
  color: #676767;
}
.q-type {
  display: inline-block;
  width: 36px;
  height: 20px;
  margin-right: 16px;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
  background-color: #ff7b1f;
  border-radius: 5px;
}
.no-type {
  background-color: #343434;
}
.type-green {
  background-color: #52ce0f;
}
.detail-title {
  padding: 40px 0;
  font-size: 26px;
  color: #333333;
  font-weight: bold;
}

.order-title {
  padding-bottom: 40px;
  font-size: 22px;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
.order-info {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  color: #666666;
  span {
    padding-left: 16px;
    color: #333333;
  }
}
.info-box {
  margin-bottom: 40px;
}
.road-btn {
  width: 75px;
  margin-left: 12px;
  font-size: 12px;
  color: #1c87ff;
  text-align: center;
  line-height: 25px;
  border-radius: 14px;
  border: 1px solid #1c87ff;
  cursor: pointer;
  .iconfont-icon {
    position: relative;
    top: 2px;
  }
}
/deep/ {
  .el-collapse-item__header {
    border: none;
  }
  .el-collapse {
    border: none;
  }
  .el-dialog {
    padding: 0 20px 0;
    border-radius: 9px;
  }
  .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
  .el-select {
    flex: 1;
    margin-left: 14px;
  }
  .el-dialog__body {
    padding-top: 20px;
  }
  .el-date-editor {
    width: 134px;
    margin-right: 10px;
  }
}
.time-box {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  padding-left: 14px;
}
.order-button {
  width: 176px;
  margin: 40px auto;
  line-height: 44px;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  background: #f1a475;
  border-radius: 6px;
  cursor: pointer;
}
.m-test {
  padding: 30px 0;
  .w1 {
    text-align: center;
    margin-bottom: 26px;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
    line-height: 28px;
    text-align: center;
    font-style: normal;
  }
  .m-btn {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 196px;
    height: 50px;
    background: #f1a475;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    line-height: 25px;
    text-align: center;
    font-style: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myCoursePlay.vue